export class PaymentDetails {
  accountType: string;
  amount: number;
  bankName: string;
  cardExpirationMonth: string;
  cardExpirationYear: string;
  cardType: string;
  confirmationNumber?: string;
  email?: string;
  holderZip: string;
  lastFourDigits: string;
  name: string;
  paymentDate: Date;
  paymentCategory: string;
  policyNumber: string;
  servicingFee: number;
  tokenId: string;
  totalPaymentAmount: number;
}
